import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation hook from react-i18next
import "../../Assets/Css/HomeCss/Section.css";
import Card from "./Card";
import axiosClient from "../../AxiosClient";
import BannerSearch from "../BannerSearch";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { specialtySearchUrl } from "../../Services/SpecializationService";

const HOME_SPECIALTIES = [
  { label: "Dental", specialty: "Dentist", icon: "/img/dental.png" },
  { label: "General Physician", specialty: "General Physician", icon: "/img/general_physican.png" },
  { label: "Cardiology", specialty: "Cardiologist", icon: "/img/cardiology.png" },
  { label: "Nephrology", specialty: "Nephrologist", icon: "/img/nephrology.png" },
  { label: "Gynecology", specialty: "Gynecologist", icon: "/img/gynecology.png" },
];

// Doctors carousel: keeps moving on its own and pauses while the cursor is over a card
const doctorSliderSettings = (count) => ({
  dots: true,
  arrows: false,
  infinite: count > 4,
  speed: 600,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  pauseOnFocus: true,
  swipeToSlide: true,
  responsive: [
    { breakpoint: 1280, settings: { slidesToShow: 3, infinite: count > 3 } },
    { breakpoint: 900, settings: { slidesToShow: 2, infinite: count > 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1, infinite: count > 1 } },
  ],
});

// Custom Arrow Components
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow custom-next-arrow" onClick={onClick}>
      <i className="fa-solid fa-chevron-right"></i>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow custom-prev-arrow" onClick={onClick}>
      <i className="fa-solid fa-chevron-left"></i>
    </div>
  );
};

const Section = () => {
  const { t } = useTranslation(); // Use the useTranslation hook to access translation functions
  const [Doctors, setDoctors] = useState([]);

  const categorySliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        }
      }
    ]
  };

  useEffect(() => {
    axiosClient
      .post("/doctor/home")
      .then((res) => setDoctors(Array.isArray(res.data) ? res.data : res.data?.data || []))
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <div className="Section_bg"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/d-banner.png)`,
        backgroundSize: "contain",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
      }}
      
      >
        <div className="_container d_flex _height pd-top">
          <div className="_height">
            <h1 className="_title_Section">{t("section_title")}</h1>
            <p className="su_text">{t("section_description")}</p>
            {/* <button className="_btn btn_bg_primary _btn_Section mr_top">
              <Link to={"/recherche"}>{t("schedule_appointment")}</Link>
            </button> */}

           <BannerSearch/>
          </div>
          <div className="Section_img">
            {/* <span className="circle"></span> */}
            {/* <img
              src="./img/doctor-2.png"
              className="_img"
              alt=""
              style={{ display: "initial" }}
            /> */}
            {/* <span className="_heart_icon circle_1">
              <span className="circle_2">
                <i className="fa-solid fa-heart-pulse"></i>
              </span>
            </span> */}
            {/* <div className="_info">
              <div className="_info_div ">
                <div className="_info_icon">
                  <i className="fa-regular fa-user-plus"></i>
                </div>
                <div className="_info_text">
                  <p> 100,000+ </p>
                  <p> patients/yers </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <article className="height_article_1 _container">
        <div className=" article_info text_center">
          <h1>{t("service_quality_title")}</h1>
          <p>{t("service_quality_description")}</p>
          <div className="article_img">
            <img
              src="./img/Rectangle 4.jpg"
              alt=""
              style={{ display: "initial" }}
            />
            <img
              src="./img/Rectangle 5.jpg"
              alt=""
              style={{ display: "initial" }}
            />
            <img
              src="./img/Rectangle 6.jpg"
              alt=""
              style={{ display: "initial" }}
            />
            <img
              src="./img/Rectangle 6.jpg"
              alt=""
              style={{ display: "initial" }}
            />
            <img
              src="./img/Rectangle 6.jpg"
              alt=""
              style={{ display: "initial" }}
            />
          </div>
        </div>
      </article> */}
 <section className="two-banner-section">
      <div className="banner-container">
        <div className="banner banner-1">
          <Link to="/search-doctor?type=video" aria-label="Consult online now">
            <img src="/img/homepage-banner-1.jpg" alt="Consult Online Now - video consultation with specialists" className="banner-img" />
          </Link>
        </div>
        <div className="banner banner-2">
          <Link to="/search-doctor?type=clinic" aria-label="Book an in-clinic appointment">
            <img src="/img/homepage-banner-2.jpg" alt="In-Clinic Appointments - book an in-person visit" className="banner-img" />
          </Link>
        </div>
      </div>
    </section>
<article className="height_article_1 _container">
  <div className="article_info">
    <div className="header_section">
      <h1 className="left_heading">{t("service_quality_title")}</h1>
      <Link to="/search-doctor" className="view_all_link"><u>View All</u></Link>
    </div>
    <p className="description_text">{t("service_quality_description")}</p>
    <div className="mt-6">
      <Slider {...categorySliderSettings}>
        {HOME_SPECIALTIES.map((item) => (
          <div className="px-2" key={item.specialty}>
            <Link
              to={specialtySearchUrl(item.specialty)}
              className="bg-gray-50 block p-6 border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 hover:border-blue-300 transition-colors cursor-pointer"
            >
              <div className="flex flex-col items-center justify-center text-center">
                <img src={item.icon} width={60} height={60} alt={item.label} className="mb-3" />
                <h5 className="text-lg font-semibold text-gray-800">{item.label}</h5>
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
   
  </div>
</article>



      {Doctors.length > 0 && (
        <section className="book_doctors_section">
          <div className="_container">
            <h2 className="book_doctors_title">{t("book_our_doctors")}</h2>
            <Slider {...doctorSliderSettings(Doctors.length)}>
              {Doctors.map((doctor) => (
                <div className="px-2 pb-4 pt-2 h-full" key={doctor.id}>
                  <Card doctor={doctor} />
                </div>
              ))}
            </Slider>
          </div>
        </section>
      )}

      {/* <aside className="_container height_aside">
        <div className="aside_bg">
          <span className="circle_bg"></span>
          <span className="circle_border"></span>
          <h1>{t("take_care_of_yourself")}</h1>
          <button className="_btn btn_bg_white ">{t("schedule_appointment")}</button>
          <span className=" circle_bottom_border "></span>
        </div>
      </aside> */}
    </>
  );
};

export default Section;
